export default __webpack_public_path__ + "static/media/url2.12e1b75e.png";